/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
  BuilderNavigationService,
  BuilderUserContext,
  CommonActions,
  ListActionPipelines,
} from '@gh/builder-shared';
import { ROW_DELETED_CLASS } from '@gh/common-internal-shared';
import { AppRouter, getRouteInitData } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import { DialogService, NotificationService, WaitingService } from '@gh/core-ui';
import { GridDefinition, GridDefinitionFactory } from '@gh/core-ui-grid';
import { BaseDesignBusinessService } from '../../resources';
import { BaseDesignListItem } from '../../resources/base-design.model';

@Component({
  selector: 'gh-base-design-list',
  template: require('./base-design-list.component.html'),
})
export class BaseDesignListComponent implements OnInit {

  baseDesignGridDefinition: GridDefinition;
  dataSource: SlicedDataSource<BaseDesignListItem>;
  showDeleted: boolean = false;

  constructor(private route: ActivatedRoute,
              private router: AppRouter,
              private userContext: BuilderUserContext,
              private waitingService: WaitingService,
              private businessService: BaseDesignBusinessService,
              private navigationService: BuilderNavigationService,
              private notificationService: NotificationService,
              private dialogService: DialogService,
              private pipelines: ListActionPipelines,
              private translationService: TranslationService,
              private commonActions: CommonActions,
              private gridDefinitionFactory: GridDefinitionFactory) {
  }

  ngOnInit(): void {
    const { dataSource } = getRouteInitData(this.route);
    this.dataSource = dataSource;
    this.baseDesignGridDefinition = this.gridDefinitionFactory.buildManual([
     {
       field: 'name',
       headerName: this.translationService.get('lbl_plan_name'),
       comparator: () => 0,
     },
     {
       field: 'designSeriesName',
       headerName: this.translationService.get('lbl_design_series'),
       width: 140,
       comparator: () => 0,
     },
      {
        field: 'bedrooms',
        headerName: this.translationService.get('lbl_bedrooms'),
        comparator: () => 0,
      },
      {
        field: 'bathrooms',
        headerName: this.translationService.get('lbl_bathrooms'),
        comparator: () => 0,
      },
      {
        field: 'carSpaces',
        headerName: this.translationService.get('lbl_car_spaces'),
        comparator: () => 0,
      },
      {
        field: 'storeys',
        headerName: this.translationService.get('lbl_storeys'),
        comparator: () => 0,
      },
      {
        field: 'floorArea',
        headerName: this.translationService.get('lbl_floor_area'),
        comparator: () => 0,
      },

    ], { // tslint:disable-line:align
      rowClassRules: {
        [ROW_DELETED_CLASS]: ({ data }: { data: any }) => data.isActive !== true,
      },
      getRowNodeId: ({ baseDesignId }: BaseDesignListItem) => baseDesignId,
    });
  }

  goToAel(entityId?: ID, entityType?: string, label?: string): void {
    this.navigationService.goToAel({
      entityId: entityId || void 0,
      entityType: entityType || 'BASE_DESIGN',
      label: label || 'lbl_base_design',
    });
  }

  reload(): void {
    this.dataSource = this.businessService.findAllAsDataSource({
      showDeleted: this.showDeleted,
    });
  }

  onOpenDetails(event: any): void {
    if (event.data.empty) {
      return;
    }
    this.router.navigateToChild([`/setup/base-designs/${event.data.id}`]);
  }
}
